import { isHTMLAnchorElement, isHTMLButtonElement } from '../../helpers';
function isFocusable(element) {
    return ((isHTMLAnchorElement(element) && element.getAttribute('data-disabled') !== 'true') ||
        (isHTMLButtonElement(element) && !element.disabled));
}
export function getFocusableElements(elements) {
    return elements.map((element) => {
        return { element, focusable: isFocusable(element) };
    });
}
//# sourceMappingURL=helpers.js.map